// redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../config/api";
import config from "../../config/config";
import { getCurrentLoggedInSessionToken } from "../../config/userPool";

const {
  SHUTTLE_BUS_BOOKING_REPORT_ENDPOINT,
} = config.api_endpoint;

const initialState = {
  loading: false,
  report_list: [],
  error: null,
};

export const fetchShuttleBusBookingReport = createAsyncThunk(
  "report/fetchShuttleBusBookingReport",
  async (data, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${SHUTTLE_BUS_BOOKING_REPORT_ENDPOINT}`;
      const results = await api.post(url, JSON.stringify(data), token);

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

const shuttleBusReportSlice = createSlice({
  name: "shuttleBusReportSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShuttleBusBookingReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShuttleBusBookingReport.fulfilled, (state, action) => {
        state.loading = false;
        state.report_list = action.payload;
      })
      .addCase(fetchShuttleBusBookingReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

  },
});

const ShuttleBusReportReducer = shuttleBusReportSlice.reducer;
export default ShuttleBusReportReducer;
